import React, { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePriceContext } from '../Components/Context/PriceContext';

const PaymentGuard = ({ children }) => {
  const { paymentData } = usePriceContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!paymentData?.deliveryTurnaround) {
      navigate('/price-calculator', { replace: true });
    }
  }, [paymentData, navigate]);

  return paymentData?.deliveryTurnaround ? children : null;
};

export default PaymentGuard;